var _rect, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthlyForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 22,
    viewBox: "0 0 46 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 44.75,
    height: 22,
    rx: 3,
    fill: "#336094"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92058 15V7.245H10.9216L13.9136 13.988H13.5836L16.5756 7.245H17.5656V15H16.5316V8.796H16.8946L14.1006 15H13.3856L10.5916 8.796H10.9656V15H9.92058Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 9.66819H32.6972L34.6381 7.67055C32.7043 5.75792 29.5732 5.68708 27.6393 7.59971C25.7055 9.51943 25.7055 12.6151 27.6393 14.5348C29.5732 16.4545 32.7043 16.4545 34.6381 14.5348C35.6015 13.5855 36.0832 12.4734 36.0832 11.0708H37.5C37.5 12.4734 36.8766 14.2939 35.6299 15.5265C33.1435 17.9917 29.1057 17.9917 26.6193 15.5265C24.1399 13.0684 24.1187 9.07315 26.6051 6.61506C29.0915 4.15698 33.0797 4.15698 35.5661 6.61506L37.5 4.62451V9.66819ZM31.4788 8.16642V11.177L33.9581 12.6505L33.4481 13.5076L30.4162 11.7083V8.16642H31.4788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyForecast);
export default __webpack_public_path__ + "static/media/monthlyForecast.323a2ffdeec96c407ae0ab2eaf5ae4eb.svg";
export { ForwardRef as ReactComponent };